/**
 * HTTP Status Codes
 */
export enum HttpStatusCode {
  Ok = 200,
  Created = 201,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  InternalServerError = 500,
  ServiceUnavailable = 503,
  RequestThrottling = 429,
  RequestTimeOut = 408,
}

/**
 * Header keys for request timing and tracking
 */
export const requestStartTime = 'x-request-start-time';
export const duration = 'x-request-duration';

export const TenantEntityPageSize = 5;
export const TenantEntityType = "sit";
export const TenantLabelEntityType = 'label';
export const TenantPolicyEntityType = 'policy';

export const LabelTabName = 'labels';
export const PolicyTabName = 'policies';

export const AvailableStatus = 'Available';
export const PartiallyDeployedStatus = 'Partially Deployed';
export const ErrorStatus = 'Error';

export const FilledAppearance = 'filled';
export const BadgeSuccessColor = 'success';
export const BadgeDangerColor = 'danger';
export const BadgeWarningColor = 'warning';

// Dashboard / Tenant view text constants
export const BASE_TEMPLATE_TENANT = 'Microsoft Tenant';
export const DASHBOARD_HEADING = 'Deployment Dashboard';
export const TENANT_HEADING = 'Tenant Rollout View';


/**
 * Protection Level Constants for PillBadge Component
 */
export const PROTECTION_LEVELS = {
  // Success (Green) - Highest protection levels
  SUCCESS: [
    'highly confidential',
    'high',
    'maximum',
    'advanced'
  ],

  // Warning (Orange) - Medium protection levels
  WARNING: [
    'confidential',
    'medium'
  ],

  // Informative (Blue) - Basic protection levels
  INFORMATIVE: [
    'general',
    'basic',
    'low'
  ],

  // Danger (Red) - No protection
  DANGER: [
    'none',
    'no protection',
    ''
  ]
} as const;

/**
 * Badge Color Types
 */
export type BadgeColor = 'success' | 'warning' | 'danger' | 'informative';

/**
 * View type for navigation
 */
export type AppView = 'dashboard' | 'tenant';

/**
 * Browser tab title constants
 */
export const APP_TITLE = 'DLP Multi-Tenant Capability';

export const VIEW_TITLES: Record<AppView, string> = {
  dashboard: DASHBOARD_HEADING,
  tenant: TENANT_HEADING,
};

export function getPageTitle(view: AppView, tenantName?: string | null): string {
  const viewTitle = VIEW_TITLES[view];
  if (!viewTitle) return APP_TITLE;
  if (tenantName) return `${viewTitle} - ${tenantName} - ${APP_TITLE}`;
  return `${viewTitle} - ${APP_TITLE}`;
}
